// src/hooks/banks/useDeleteBank.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteBank } from "../../api/apiBanks";
import { useTranslation } from "react-i18next";

function useDeleteBank() {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const { mutate: deleteBankMutation, isPending: isDelete } = useMutation({
        mutationFn: deleteBank,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["banks"] });
            toast.success(isArabic ? "تم حذف البنك بنجاح" : "Bank deleted successfully");
        },
        onError: (err) => {
            toast.error(err?.message || (isArabic ? "فشل في حذف البنك" : "Failed to delete bank"));
        },
    });

    return { deleteBank: deleteBankMutation, isDelete };
}

export default useDeleteBank;
